(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  var NAME_RE = /^[a-zA-ZçÇöÖşŞıİğĞüÜ\s]+$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_ALLOWED_KEYS = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
  var DEFAULT_ENDPOINT = "/save-job-application-form";

  DNB.CareerForm = {
    init: function () {
      var forms = document.querySelectorAll("[data-career-form]");
      if (!forms.length) return;

      Array.prototype.forEach.call(forms, function (form) {
        DNB.CareerForm._bind(form);
      });
    },

    _bind: function (form) {
      var self = this;
      var submitBtn = form.querySelector("[data-career-submit]");
      var success = form.parentNode.querySelector("[data-career-success]");

      Array.prototype.forEach.call(form.querySelectorAll('[data-rule="phone"]'), function (input) {
        self._initPhoneField(input);
      });

      Array.prototype.forEach.call(form.querySelectorAll("[data-auto-grow]"), function (textarea) {
        self._bindTextarea(textarea);
      });

      function handle(e) {
        if (e) e.preventDefault();
        if (self._isSubmitting(form)) return;
        if (!self._validate(form)) return;

        self._lockSubmit(form, submitBtn);
        self._submit(form, self._resolveEndpoint(form), submitBtn, success);
      }

      form.addEventListener("submit", handle);
      if (submitBtn) submitBtn.addEventListener("click", handle);

      var controls = form.querySelectorAll(".form-field__control, .form-check__input");
      Array.prototype.forEach.call(controls, function (ctrl) {
        var ev = ctrl.type === "checkbox" ? "change" : "input";
        ctrl.addEventListener(ev, function () {
          var wrap = ctrl.closest(".form-field, .form-check");
          if (wrap && self._checkControl(ctrl)) wrap.classList.remove("is-error");
          self._hideFormError(form, submitBtn);
        });
      });
    },

    _bindTextarea: function (textarea) {
      var counter = textarea.parentNode.querySelector("[data-char-counter]");
      var max = parseInt(textarea.getAttribute("maxlength"), 10) || 3000;

      function sync() {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";

        if (counter) {
          counter.textContent = textarea.value.length + " / " + max;
        }
      }

      textarea.addEventListener("input", sync);
      sync();
    },

    _initPhoneField: function (input) {
      var self = this;

      input.setAttribute("inputmode", "numeric");
      input.setAttribute("autocomplete", "tel-national");
      input.setAttribute("maxlength", "13");

      input.addEventListener("keydown", function (e) {
        if (e.ctrlKey || e.metaKey || e.altKey) return;
        if (PHONE_ALLOWED_KEYS.indexOf(e.key) !== -1) return;
        if (!/^\d$/.test(e.key)) e.preventDefault();
      });

      input.addEventListener("input", function () {
        var formatted = self._formatTrPhone(input.value);
        if (input.value !== formatted) input.value = formatted;
      });

      input.addEventListener("paste", function (e) {
        e.preventDefault();
        var pasted = (e.clipboardData || window.clipboardData).getData("text");
        input.value = self._formatTrPhone(pasted);
      });
    },

    _formatTrPhone: function (value) {
      var digits = String(value || "").replace(/\D/g, "").slice(0, 10);
      var parts = [];

      if (digits.length > 0) parts.push(digits.slice(0, 3));
      if (digits.length > 3) parts.push(digits.slice(3, 6));
      if (digits.length > 6) parts.push(digits.slice(6, 8));
      if (digits.length > 8) parts.push(digits.slice(8, 10));

      return parts.join(" ");
    },

    _validate: function (form) {
      var self = this;
      var controls = form.querySelectorAll("[data-rule]");
      var firstInvalid = null;

      Array.prototype.forEach.call(controls, function (ctrl) {
        var wrap = ctrl.closest(".form-field, .form-check");
        if (!wrap) return;
        var ok = self._checkControl(ctrl);
        wrap.classList.toggle("is-error", !ok);
        if (!ok && !firstInvalid) firstInvalid = ctrl;
      });

      if (firstInvalid && firstInvalid.focus) {
        try { firstInvalid.focus(); } catch (err) {}
      }
      return !firstInvalid;
    },

    _checkControl: function (ctrl) {
      var rule = ctrl.getAttribute("data-rule");
      var val = (ctrl.value || "").trim();

      switch (rule) {
        case "name":
          if (typeof ValidateName === "function") {
            return ValidateName(val);
          }
          return val.length >= 2 && NAME_RE.test(val);
        case "email":
          if (typeof ValidateMail === "function") {
            return ValidateMail(val);
          }
          return EMAIL_RE.test(val);
        case "phone": {
          var digits = val.replace(/\D/g, "");
          if (digits.length !== 10) return false;
          if (typeof ValidatePhone === "function") {
            return ValidatePhone(digits);
          }
          return /^\d{10}$/.test(digits);
        }
        case "checkbox":
          return ctrl.checked === true;
        case "file": {
          var block = ctrl.closest("[data-file-upload]");
          if (block && DNB.CareerUpload && typeof DNB.CareerUpload.isValid === "function") {
            return DNB.CareerUpload.isValid(block);
          }
          return false;
        }
        case "required":
        default:
          return val.length >= 2;
      }
    },

    _resolveEndpoint: function (form) {
      return form.getAttribute("data-career-endpoint") || DEFAULT_ENDPOINT;
    },

    _isSubmitting: function (form) {
      return form.getAttribute("data-career-submitting") === "true";
    },

    _setSubmitting: function (form, isSubmitting) {
      if (isSubmitting) {
        form.setAttribute("data-career-submitting", "true");
      } else {
        form.removeAttribute("data-career-submitting");
      }
    },

    _lockSubmit: function (form, submitBtn) {
      this._setSubmitting(form, true);

      if (!submitBtn) return;

      submitBtn.disabled = true;
      submitBtn.setAttribute("disabled", "disabled");
      submitBtn.setAttribute("aria-busy", "true");
    },

    _unlockSubmit: function (form, submitBtn) {
      this._setSubmitting(form, false);

      if (!submitBtn) return;

      submitBtn.disabled = false;
      submitBtn.removeAttribute("disabled");
      submitBtn.removeAttribute("aria-busy");
    },

    _consentValue: function (form, name) {
      var el = form.querySelector('[name="' + name + '"]');
      return el && el.checked ? "true" : "false";
    },

    _buildPayload: function (form) {
      var fullNameEl = form.querySelector('[name="fullname"]');
      var emailEl = form.querySelector('[name="email"]');
      var phoneEl = form.querySelector('[name="phone"]');
      var coverEl = form.querySelector('[name="coverLetter"]');
      var cvEl = form.querySelector('[name="cv"]');
      var payload = new FormData();

      payload.append("FullName", fullNameEl ? fullNameEl.value.trim() : "");
      payload.append("Email", emailEl ? emailEl.value.trim() : "");
      payload.append("Phone", phoneEl ? phoneEl.value.replace(/\D/g, "") : "");
      payload.append("CoverLetter", coverEl ? coverEl.value.trim() : "");

      if (cvEl && cvEl.files && cvEl.files[0]) {
        payload.append("Cv", cvEl.files[0], cvEl.files[0].name);
      }

      payload.append("ConsentInfo", this._consentValue(form, "consentInfo"));
      payload.append("ConsentExplicit", this._consentValue(form, "consentExplicit"));
      payload.append("ConsentExtra", this._consentValue(form, "consentExtra"));
      payload.append("ConsentReference", this._consentValue(form, "consentReference"));

      return payload;
    },

    _getErrorEl: function (form, submitBtn) {
      var container = form.parentNode;
      var errorEl = container ? container.querySelector("[data-career-error]") : null;

      if (!errorEl && container && submitBtn) {
        errorEl = document.createElement("p");
        errorEl.className = "cform__note is-error";
        errorEl.setAttribute("data-career-error", "");
        errorEl.hidden = true;
        submitBtn.parentNode.insertBefore(errorEl, submitBtn);
      }

      return errorEl;
    },

    _showFormError: function (form, submitBtn, message) {
      var errorEl = this._getErrorEl(form, submitBtn);
      if (!errorEl) return;

      errorEl.textContent = message;
      errorEl.hidden = false;
      errorEl.classList.add("is-error");
      errorEl.setAttribute("role", "alert");
    },

    _hideFormError: function (form, submitBtn) {
      var errorEl = this._getErrorEl(form, submitBtn);
      if (!errorEl) return;

      errorEl.textContent = "";
      errorEl.hidden = true;
      errorEl.removeAttribute("role");
    },

    _resetForm: function (form) {
      form.querySelectorAll("[data-file-upload]").forEach(function (block) {
        if (DNB.CareerUpload && typeof DNB.CareerUpload._reset === "function") {
          DNB.CareerUpload._reset(block);
        }
      });

      form.querySelectorAll("[data-auto-grow]").forEach(function (textarea) {
        textarea.style.height = "auto";
        var counter = textarea.parentNode.querySelector("[data-char-counter]");
        var max = parseInt(textarea.getAttribute("maxlength"), 10) || 3000;
        if (counter) counter.textContent = "0 / " + max;
      });
    },

    _submit: function (form, endpoint, submitBtn, success) {
      var self = this;

      self._hideFormError(form, submitBtn);
      if (success) success.classList.remove("is-active");

      fetch(endpoint, {
        method: "POST",
        body: self._buildPayload(form),
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      })
        .then(function (response) {
          return response.json().catch(function () {
            return { success: false, message: "Sunucudan geçersiz yanıt alındı." };
          });
        })
        .then(function (data) {
          if (data && data.success === true) {
            if (success) success.classList.add("is-active");
            form.reset();
            self._resetForm(form);
            return;
          }

          self._showFormError(
            form,
            submitBtn,
            (data && data.message) || "Form gönderilemedi. Lütfen tekrar deneyin."
          );
        })
        .catch(function () {
          self._showFormError(
            form,
            submitBtn,
            "Beklenmedik bir hata oluştu. Lütfen tekrar deneyiniz."
          );
        })
        .finally(function () {
          self._unlockSubmit(form, submitBtn);
        });
    }
  };
})(window, document);
